import React, { useEffect, useState } from 'react'
import { Card, Select, Image, Row, Col, Button, Input, List, Checkbox, Avatar, Skeleton } from 'antd'
import { useOutletContext, Link, useLocation } from "react-router-dom";
import { CloseOutlined, SearchOutlined, DownOutlined, UpOutlined, UserOutlined  } from '@ant-design/icons';
import { Loader } from "../../../../../components/Loader";
import ModalConfirmAdmission from "../../../../../components/ModalConfirmAdmission"
import ModalSuccess from "../../../../../components/ModalSuccess"
import ModalFailedAdmission from "../../../../../components/ModalFailedAdmission"
import { useDispatch, useSelector } from "react-redux";
import { setTitleProgramAttendance } from "../../../../../redux/features/blended_learning/scannerSlice";
import HomeTitle from "../../../../../components/HomeTitle/index";

import useActions from './hooks/useActions'

import BGScanner from '../../../../../assets/images/png/feature/scanner/bg_scanner.png'
import ic_checklist_attendance from '../../../../../assets/images/svgs/ic_checklist_attendance.svg';
import ic_cross_attendance from '../../../../../assets/images/svgs/ic_cross_attendance.svg';
import ic_profile_learner_attendance from '../../../../../assets/images/svgs/ic_profile_learner_attendance.svg';

// for translate
import { useTranslation } from "react-i18next";

import { colorTextList } from '../../../../../config/constant/color/index';

const ListAttendance = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [
        loading,
        userData,
        totalJourney,
        totalJourneyCompleted,
        allJourneyData,
        listJourney,
        listCourse,
        mainState
    ] = useOutletContext();
  const titleProgramAttendance = useSelector((state) => state.scannerBlended.titleProgramAttendance);
    const [valueSearch, setValueSearch] = useState("")

    const { 
        loadingListUser,
        listDataUser,
        useridCheckin,
        setUseridCheckin,
        statusCheckin,
        submitCheckinUser,
        userFullnameCheckin,
        setUserFullnameCheckin,
        sucUserFullname,
        sucUserDateCheckin,
        setSucUserFullname,
        setSucUserDateCheckin,
        setStatusCheckin
     } = useActions(valueSearch);

     
       const location = useLocation();

    const onSearch = (searchValue) => {
        setValueSearch(searchValue)
    }

    const handleCheck = (data, userid, firstname, lastname) => {
        if(data.target.checked === true && userid !== undefined){
            setUseridCheckin(userid)
            setUserFullnameCheckin(firstname+" "+lastname)
        }
        // console.log(data.target.checked)
        // console.log(userid)
    }

    const checkChecked = (userid, ischeckin) => {
        // console.log(ischeckin)
        // console.log(userid)
        if(ischeckin === 1){
            return true;
        } else {
            if(userid === useridCheckin){
                return true;
            } else {
                return false;
            }
        }
    }
    const getProgramTitle = () => {
        const url = location.pathname;
        const arrId = url.split("/");
        
        const target = listJourney.find(item => item.id === parseInt(arrId[2]))
        dispatch(setTitleProgramAttendance(target.name))
    }

    useEffect(() => {
        if(loading === false) getProgramTitle();
    },[loading])

    return(
        <div style={{width:'100%',height:"100%",background:'#FFF8F4'}}>
            <div style={{
                width:'100%',height:"100%",background:'#FFF8F4'}}>
                <Row align={"top"} style={{
                    marginBottom: 0,
                    marginLeft:0,
                    marginRight:"auto",
                    lineHeight: "normal",
                    padding:"18px 40px"
                }}>
                  <div style={{
                    width: "100%",
                    textAlign:"left"
                }}>
                    {
                        loading === true ?
                        <Skeleton.Input
                          active
                          size={30}
                          style={{ minWidth: "250px" }}
                        />
                        :
                        <HomeTitle textTitle={titleProgramAttendance} dynamic={false} />
                    }
                  </div>
                </Row>
                <Card className='card-list-user-attendance' style={{borderRadius:8,margin:"0 32px",height:"auto"}}>
                    <div className='search-bar-attendance' style={{lineHeight:"normal"}}>
                        <Input 
                            className='search-table-attendance'
                            name='search-name-attendance'
                            style={{
                                    color: colorTextList,
                                    borderRadius:50,
                                    margin:"0 0 24px 0",
                                    height:38,
                                    fontSize:14,
                                }}
                            size="large"
                            onPressEnter={(e) => onSearch(e.target.value)}
                            onChange={(e) => setValueSearch(e.target.value)}
                            placeholder={t("feature.feature_scanner.enter_participant_name")}
                            prefix={<SearchOutlined style={{fontSize:14,color:"rgba(0,0,0,0.25)"}}  />} 
                        />
                    </div>
                    <div className='list-user-attendance' style={{lineHeight:"normal",paddingTop:loadingListUser ? 100 : 0}}>
                        {
                            loadingListUser ? <Loader /> :
                            
                            <List
                                className='limit-list text-start list-data-user-attendance'
                                itemLayout="horizontal"
                                dataSource={listDataUser}
                                style={{width:"100%",height:"auto",maxHeight:"calc(100vh - 315px)",overflowY:"auto"}}
                                size="medium"
                                renderItem={(item, index) => (
                                    <List.Item 
                                        key={item.id} 
                                        data-id={item.id} 
                                        id="list-data-user-attendance"
                                    >
                                        <List.Item.Meta
                                            className='align-items-center'
                                            description={
                                                <div>
                                                    <Checkbox checked={checkChecked(item.user_id, item.is_check_in)} onChange={(e) => handleCheck(e, item.user_id, item.firstname, item.lastname)} disabled={item.is_check_in === 1 ? true : false}>
                                                        <div style={{marginLeft:12}}>
                                                            <div style={{fontSize:14,fontWeight:500}}>
                                                                {item.firstname} {item.lastname}
                                                            </div>
                                                            <div style={{fontSize:14,color:item.is_check_in === 1 ? "#BEBEBE" : "#AAAAAD"}}>
                                                                {item.email}
                                                            </div>
                                                        </div>
                                                    </Checkbox>
                                                </div>
                                            }
                                        />
                                    </List.Item>
                                )}
                            />
                        }
                    </div>
                </Card>
            </div>

            <ModalFailedAdmission
                setUseridCheckin={setUseridCheckin}
                setUserFullnameCheckin={setUserFullnameCheckin}
                setSucUserFullname={setSucUserFullname}
                setSucUserDateCheckin={setSucUserDateCheckin}
                setStatusCheckin={setStatusCheckin}
                submitCheckinUser={submitCheckinUser}
                useridCheckin={useridCheckin}
                statusCheckin={statusCheckin}
            />

            <ModalConfirmAdmission
                setUseridCheckin={setUseridCheckin}
                setUserFullnameCheckin={setUserFullnameCheckin}
                submitCheckinUser={submitCheckinUser}
                useridCheckin={useridCheckin}
                userFullnameCheckin={userFullnameCheckin}
                statusCheckin={statusCheckin}
            />
            <ModalSuccess
                statusCheckin={statusCheckin}
                setUseridCheckin={setUseridCheckin}
                setUserFullnameCheckin={setUserFullnameCheckin}
                setSucUserFullname={setSucUserFullname}
                setSucUserDateCheckin={setSucUserDateCheckin}
                setStatusCheckin={setStatusCheckin}
                sucUserFullname={sucUserFullname}
                sucUserDateCheckin={sucUserDateCheckin}
            />

        </div>
    )
}

export default ListAttendance